import { nativeAppSwaUserAgentTokens } from "../defines";
import { window } from "../window";

/**
 * getWebViewType assesses whether the SWA native app custom user agent suffix exists.
 */

export const getWebViewType = (passedUserAgent?: string): string | undefined => {
  const userAgent = passedUserAgent ?? window?.navigator?.userAgent ?? "";

  return nativeAppSwaUserAgentTokens.find((userAgentValue) => userAgent.endsWith(userAgentValue));
};
